export const fuseRouter = [{
        path: '',
        redirect: 'notice'
    },
    {
        path: 'index',
        meta: {
            title: '数据统计',
        },
        component: () =>
            import ('../views/fuse/page/index'),
    },
    {
        path: 'notice',
        meta: {
            title: '通知',
        },
        component: () =>
            import ('../views/fuse/page/notice'),
    },
    {
        path: 'noticeDetail',
        meta: {
            title: '通知详情',
        },
        component: () =>
            import ('../views/fuse/page/noticeDetail'),
    },
    {
        path: 'account',
        meta: {
            title: '帐号管理',
        },
        component: () =>
            import ('../views/fuse/page/account'),
    },
    {
        path: 'info',
        meta: {
            title: '机构信息',
        },
        component: () =>
            import ('../views/fuse/page/info'),
    },
    {
        path: 'class',
        meta: {
            title: '班级管理',
        },
        component: () =>
            import ('../views/fuse/page/class'),
    },
    {
        path: 'student',
        meta: {
            title: '学生管理',
        },
        component: () =>
            import ('../views/fuse/page/student'),
    },
    {
        path: 'studentExamine',
        meta: {
            title: '学生审核',
        },
        component: () =>
            import ('../views/fuse/page/studentExamine'),
    },




    {
        path: 'studentDetail',
        meta: {
            title: '学生详情',
        },
        component: () =>
            import ('../views/fuse/page/studentDetail'),
    },
    {
        path: 'course',
        meta: {
            title: '课程管理',
        },
        component: () =>
            import ('../views/fuse/page/course'),
    },
    {
        path: 'exam',
        meta: {
            title: '考试管理',
        },
        component: () =>
            import ('../views/fuse/page/exam'),
    },
    {
        path: 'examDetail',
        meta: {
            title: '考试详情',
        },
        component: () =>
            import ('../views/fuse/page/examDetail'),
    },
    {
        path: 'invitationSign',
        meta: {
            title: '邀请报名',
        },
        component: () =>
            import ('../views/fuse/page/invitationSign'),
    },
    {
        path: 'examinee',
        meta: {
            title: '考生列表',
        },
        component: () =>
            import ('../views/fuse/page/examinee'),
    },
    {
        path: 'examineeDetail',
        meta: {
            title: '考生详情',
        },
        component: () =>
            import ('../views/fuse/page/examineeDetail'),
    },
    {
        path: 'practiceBase',
        meta: {
            title: '实习管理',
        },
        component: () =>
            import ('../views/fuse/page/practiceBase'),
    },
    {
        path: 'practiceBaseDetail',
        meta: {
            title: '实习岗位详情',
        },
        component: () =>
            import ('../views/fuse/page/practiceBaseDetail'),
    },
    {
        path: 'practicePush',
        meta: {
            title: '职位推送',
        },
        component: () =>
            import ('../views/fuse/page/practicePush'),
    },
    {
        path: 'practiceStudent',
        meta: {
            title: '实习生列表',
        },
        component: () =>
            import ('../views/fuse/page/practiceStudent'),
    },
    {
        path: 'practicePush',
        meta: {
            title: '实习推送',
        },
        component: () =>
            import ('../views/fuse/page/practicePush'),
    },
    {
        path: 'userInfo',
        meta: {
            title: '个人中心',
        },
        component: () =>
            import ('../views/fuse/page/userInfo'),
    },
]